(() => {
  const initialized = 'data-subcategory-navigation-initialized';
  let outsideCloseBound = false;

  const getDisclosurePanel = (disclosure) => {
    const toggle = disclosure.querySelector('[data-subcategory-disclosure-toggle]');
    const panelId = toggle?.getAttribute('aria-controls');
    return panelId ? document.getElementById(panelId) : null;
  };

  const positionSubcategoryColumn = (panel) => {
    const column = panel.closest('[data-subcategory-column]');
    const inner = column?.parentElement;
    if (!column || !inner) return;

    const columnIndex = Number.parseInt(column.style.getPropertyValue('--subcategory-column'), 10) - 1;
    const families = [...inner.children].filter((child) => child.classList?.contains('dropdown__family') && !child.matches('[data-subcategory-column]'));
    const target = families[columnIndex] || families[families.length - 1];
    if (!target) return;

    const innerRect = inner.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    column.style.setProperty('--subcategory-column-top', `${targetRect.top - innerRect.top}px`);
    column.style.setProperty('--subcategory-column-left', `${targetRect.left - innerRect.left}px`);
    column.style.setProperty('--subcategory-column-width', `${targetRect.width}px`);
    column.style.setProperty('--subcategory-column-height', `${targetRect.height}px`);
  };

  const setDisclosureState = (disclosure, expanded, restoreFocus = false) => {
    const toggle = disclosure.querySelector('[data-subcategory-disclosure-toggle]');
    const panel = getDisclosurePanel(disclosure);
    if (!toggle || !panel) return;

    toggle.setAttribute('aria-expanded', String(expanded));
    panel.hidden = !expanded;
    disclosure.classList.toggle('is-expanded', expanded);
    const column = panel.closest('[data-subcategory-column]');
    if (column) {
      column.hidden = !expanded && !column.querySelector('[data-subcategory-disclosure-panel]:not([hidden])');
    }
    if (restoreFocus) toggle.focus();
  };

  const closeOtherDisclosures = (root, current) => {
    root.querySelectorAll('[data-subcategory-disclosure].is-expanded').forEach((disclosure) => {
      if (disclosure !== current) setDisclosureState(disclosure, false);
    });
  };

  const initializeMoreControls = (root) => {
    root.querySelectorAll('[data-subcategory-more]').forEach((button) => {
      if (button.hasAttribute(initialized)) return;
      button.setAttribute(initialized, '');
      button.addEventListener('click', () => {
        const group = button.closest('.subcategory-links__group');
        const expanded = button.getAttribute('aria-expanded') === 'true';
        group?.querySelectorAll('[data-subcategory-extra]').forEach((link) => {
          link.hidden = expanded;
        });
        button.setAttribute('aria-expanded', String(!expanded));
        const label = button.querySelector('[data-subcategory-more-label]');
        if (label) label.textContent = expanded ? button.dataset.moreLabel : button.dataset.lessLabel;
      });
    });
  };

  const initializeDisclosures = (root) => {
    root.querySelectorAll('[data-subcategory-disclosure]').forEach((disclosure) => {
      if (disclosure.hasAttribute(initialized)) return;
      disclosure.setAttribute(initialized, '');
      const toggle = disclosure.querySelector('[data-subcategory-disclosure-toggle]');
      const panel = getDisclosurePanel(disclosure);
      if (!toggle || !panel) return;
      let suppressFocusOpen = false;
      let closeTimer;

      const cancelScheduledClose = () => {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = undefined;
        }
      };

      const open = () => {
        cancelScheduledClose();
        closeOtherDisclosures(root, disclosure);
        positionSubcategoryColumn(panel);
        setDisclosureState(disclosure, true);
      };
      const close = (restoreFocus = false) => {
        cancelScheduledClose();
        suppressFocusOpen = restoreFocus;
        setDisclosureState(disclosure, false, restoreFocus);
        if (restoreFocus) setTimeout(() => { suppressFocusOpen = false; }, 0);
      };
      const scheduleClose = () => {
        cancelScheduledClose();
        closeTimer = window.setTimeout(() => close(), 100);
      };
      const closeOnFocusExit = () => {
        window.setTimeout(() => {
          if (!disclosure.contains(document.activeElement) && !panel.contains(document.activeElement)) close();
        }, 0);
      };
      const closeOnEscape = (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close(true);
        }
      };

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggle.getAttribute('aria-expanded') === 'true' ? close() : open();
      });
      disclosure.addEventListener('mouseenter', open);
      disclosure.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('mouseenter', open);
      panel.addEventListener('mouseleave', scheduleClose);
      disclosure.addEventListener('focusin', () => {
        if (!suppressFocusOpen) open();
      });
      panel.addEventListener('focusin', open);
      disclosure.addEventListener('focusout', closeOnFocusExit);
      panel.addEventListener('focusout', closeOnFocusExit);
      disclosure.addEventListener('keydown', closeOnEscape);
      panel.addEventListener('keydown', closeOnEscape);
    });

    if (!outsideCloseBound) {
      outsideCloseBound = true;
      document.addEventListener('pointerdown', (event) => {
        if (event.target.closest?.('[data-subcategory-disclosure], [data-subcategory-column]')) return;
        document.querySelectorAll('[data-subcategory-disclosure].is-expanded').forEach((disclosure) => {
          setDisclosureState(disclosure, false);
        });
      });
    }
  };

  const initialize = (root = document) => {
    initializeMoreControls(root);
    initializeDisclosures(root);
  };

  window.MyPeonikaSubcategoryNavigation = { initialize };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
